<template>
  <div id="app">
    <CustomAlert id="aa-alert" />
    <TopNav v-if="isLoggedIn" />
    <!-- Binding a key to the full path will remount a view if
        the detail endpoint changes-->
    <div class="main-content">
      <router-view :key="$route.fullPath"></router-view>
    </div>
    <PageFooter />
  </div>
</template>

<script>
import VueScrollTo from 'vue-scrollto'

import { TopNav, PageFooter } from '@/components/'

export default {
  name: 'app',
  components: {
    TopNav,
    PageFooter,
  },
  watch: {
    // When route changes, scroll to the top
    '$route.path': function watchRoutePath() {
      VueScrollTo.scrollTo('#app', 200)
    },
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn
    },
  },
  created() {},
}
</script>

<style lang="scss">
@import '@/styles/mixins/fontstyles';
@import '@/styles/mixins/interactions';
:root {
}
#app {
  background-color: $app-bg;
  min-height: 100vh;
  position: relative;
}
.main-content {
  padding-bottom: 15rem;
}
a {
  @include navbar-item-font();
}
h1 {
  @include page-title-font();
}
* {
  font-family: $base-font-family;
}

.tn-button {
  &--primary {
    @include button-primary();
  }
  &--secondary {
    @include button-secondary();
  }
  &--small {
    @include button-small();
  }
  &--medium {
    @include button-medium();
  }
  &--large {
    @include button-large();
  }
}
.input {
  @include input();
}
</style>
